import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Gateway} from '@models/adminstration/gateway/gateway';
import {ElasticSearchService} from '@services/elastic-search/elastic-search.service';
import {Subject} from 'rxjs';
import {NotificationService} from '@services/notification/notification.service';
import {TranslateService} from '@ngx-translate/core';
import {ElasticSearchResponseEntity} from '@models/elastic-search/response/elastic-search-response-entity';
import {takeUntil} from 'rxjs/operators';
import {GATEWAY_TYPE} from '@constants/gateway/gateway-type';

@Component({
    selector: 'scitis-admin-gateway-functions-modal',
    templateUrl: './gateway-functions-modal.component.html',
    styleUrls: ['./gateway-functions-modal.component.scss'],
    standalone: false
})
export class GatewayFunctionsModalComponent implements OnInit, OnDestroy {

  @Input()
  gateway: Gateway = new Gateway();
  @Input()
  okButtonText: string = '';
  @Input()
  rootOrganizationId: number = -1;
  @Input()
  rootMachineryGroupId: number = -1;
  @Input()
  whiteListedMachineIds: number[] = [];
  @Input()
  isSuperAdmin: boolean = false;

  cloudplugOnes: Gateway[] = new Array<Gateway>();
  isLoadingCPOnes: boolean = false;
  selectedPath: string = '';

  private destroy$: Subject<boolean> = new Subject<boolean>();
  private CURRENT_PAGE_NAME = 'Gateway functions';


  constructor(private activeModal: NgbActiveModal,
              private translation: TranslateService,
              private notificationService: NotificationService,
              private elasticSearchService: ElasticSearchService) {
  }

  ngOnInit() {
    this.setCloudplugOnes();
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

  onClose() {
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel(_$event: boolean) {
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  onOk(_$event: boolean) {
    this.gateway.configUploadRequested = false;
    this.gateway.configDownloadRequested = true;
    this.gateway.configPath = this.selectedPath;
    this.activeModal.close(this.gateway);
  }

  private setCloudplugOnes() {
    this.isLoadingCPOnes = true;
    this.elasticSearchService.listAllGatewaysByType(this.rootOrganizationId, this.rootMachineryGroupId, this.whiteListedMachineIds, this.isSuperAdmin, GATEWAY_TYPE.CPONE)
    .pipe(takeUntil(this.destroy$))
    .subscribe({
      next: (success: ElasticSearchResponseEntity) => {
        if (success?.result?.data) {
          this.cloudplugOnes = success.result.data;
        }
        this.isLoadingCPOnes = false;
      }, error: (error) => {
        this.isLoadingCPOnes = false;
        const message = this.translation.instant('Error getting gateway list.');
        this.notificationService.error(message, error, this.CURRENT_PAGE_NAME, true);
      }
    });
  }
}
